import {STRIPE_ENV, getStripeEnv, isServer} from 'mkt-ssr/lib/env';

// NB: This module is a side-effect which sets the Webpack Nonce
// value *only* in development. This is a work around for the fact
// that NextJS inlines imported CSS files in development, with
// absolutely no reasonable way to change this behavior. As
// such, in order to avoid having to add unsafe-inline to our CSP
// for development, which can mask issues which will arise in production
// we use a nonce to "allow" the inlined styles which will be extracted
// to CSS files and not subject to this issue in production.
// UNDER NO CIRCUMSTANCES SHOULD THIS BEHAVIOR
// BE USED EXPLICTLY OR OUTSIDE OF DEVELOPMENT!

function setNonce() {
  const el = document.querySelector<HTMLMetaElement>(
    'meta[name="x-stripe-dev-nonce"]',
  );

  if (el) {
    // eslint-disable-next-line camelcase
    __webpack_nonce__ = el.content;
  }
}

if (getStripeEnv() === STRIPE_ENV.DEV && !isServer()) {
  setNonce();
}
